import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import ScrollToTop from "./components/ScrollToTop";
import ScriptTagsInjector from "./components/ScriptTagsInjector";
import PageViewTracker from "./components/PageViewTracker";
import WhatsAppConversionTracker from "./components/WhatsAppConversionTracker";

// Lazy load non-critical routes
const TrafegoPago = lazy(() => import("./pages/TrafegoPago"));
const RedeSocial = lazy(() => import("./pages/RedeSocial"));
const GestaoSistema = lazy(() => import("./pages/GestaoSistema"));
const Solucoes = lazy(() => import("./pages/Solucoes"));
const LandingPage = lazy(() => import("./pages/LandingPage"));
const LldVidros = lazy(() => import("./pages/LldVidros"));
const ToqueDeVidro = lazy(() => import("./pages/ToqueDeVidro"));
const ReiDaEnergiaSolar = lazy(() => import("./pages/ReiDaEnergiaSolar"));
const EnergySolar = lazy(() => import("./pages/EnergySolar"));
const EnergiaSolar = lazy(() => import("./pages/EnergiaSolar"));
const Contrato = lazy(() => import("./pages/Contrato"));
const Contato = lazy(() => import("./pages/Contato"));
const Sobre = lazy(() => import("./pages/Sobre"));
const NotFound = lazy(() => import("./pages/NotFound"));
const DevLogin = lazy(() => import("./pages/DevLogin"));
const DevDashboard = lazy(() => import("./pages/DevDashboard"));
const ClienteLogin = lazy(() => import("./pages/ClienteLogin"));
const ClienteDashboard = lazy(() => import("./pages/ClienteDashboard"));
const PropostaDynamic = lazy(() => import("./pages/PropostaDynamic"));
const Portfolio = lazy(() => import("./pages/Portfolio"));
const PortfolioDetail = lazy(() => import("./pages/PortfolioDetail"));
const SharedReport = lazy(() => import("./pages/SharedReport"));

const queryClient = new QueryClient();

const LazyFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <ScriptTagsInjector />
        <PageViewTracker />
        <WhatsAppConversionTracker />
        <Suspense fallback={<LazyFallback />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/trafegopago" element={<TrafegoPago />} />
            <Route path="/trafegopago/contrato" element={<Contrato />} />
            <Route path="/redesocial" element={<RedeSocial />} />
            <Route path="/gestaosistema" element={<GestaoSistema />} />
            <Route path="/solucoes" element={<Solucoes />} />
            <Route path="/landingpage" element={<LandingPage />} />
            <Route path="/landingpage/lld-vidros" element={<LldVidros />} />
            <Route path="/landingpage/toquedevidro" element={<ToqueDeVidro />} />
            <Route path="/landingpage/reidaenergiasolar" element={<ReiDaEnergiaSolar />} />
            <Route path="/landingpage/energy-solar" element={<EnergySolar />} />
            <Route path="/energiasolar" element={<EnergiaSolar />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/dev/login" element={<DevLogin />} />
            <Route path="/dev" element={<DevDashboard />} />
            <Route path="/cliente/login" element={<ClienteLogin />} />
            <Route path="/cliente" element={<ClienteDashboard />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/:slug" element={<PortfolioDetail />} />
            <Route path="/proposta/:slug" element={<PropostaDynamic />} />
            <Route path="/relatorio/:token" element={<SharedReport />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
